import { html, LitElement } from 'lit-element';
import { ScopedElementsMixin } from '@open-wc/scoped-elements';
import AabInput from '@aab/sc-aab-input/src/AabInput';
import AabIcon from '@aab/sc-aab-icon/src/AabIcon';
import AabAction from '@aab/sc-aab-action/src/AabAction';
import { sy_tools_search as searchIcon, sy_shapes_close_large as closeIcon } from '@aab/sc-aab-icon-set';

import styles from './styles';

export default class AabActionbar extends ScopedElementsMixin(LitElement) {
  constructor() {
    super();
    this.actionBarTitle = '';
    this.search = false;
    this.searchPlaceholder = '';
    this.actions = [];
    this.searchValue = '';
  }

  static get properties() {
    return {
      actionBarTitle: { type: String, attribute: 'action-bar-title', reflect: true },
      search: { type: Boolean, attribute: 'search', reflect: true },
      searchPlaceholder: { type: String, attribute: 'search-placeholder', reflect: true },
      actions: { type: Array, attribute: 'actions', reflect: true },
      searchValue: { type: String, attribute: false },
    };
  }

  static get scopedElements() {
    return {
      'aab-input': AabInput,
      'aab-action': AabAction,
      'aab-icon': AabIcon,
    };
  }

  static get styles() {
    return styles;
  }

  actionClick(action) {
    if (!action.disabled) {
      const event = new CustomEvent('action-bar-action', {
        detail: action.id,
        bubbles: true,
        composed: true,
      });
      this.dispatchEvent(event);
    }
  }

  clearSearch() {
    this.searchString('');
    this.searchValue = '';
    this.focusSearchInput();
  }

  searchString(target) {
    if (target !== undefined) {
      this.dispatchEvent(new CustomEvent('action-bar-search', {
        detail: target,
        bubbles: true,
        composed: true,
      }));
    }
  }

  focusSearchInput() {
    const search = this.shadowRoot.getElementById('search');
    const input = search.shadowRoot.querySelectorAll('.form-control')[0];
    input.focus();
  }

  inputChanged(e) {
    this.searchValue = e.target.value;
    setTimeout(() => {
      this.searchString(this.searchValue);
    }, 250);
  }

  renderActions() {
    // action are limited to 3 in first version
    // TODO: if more then 3 actions, third icon will be show as "more",
    // when clicked it will have dropdown with remaining actions (dependency on fly out menu component)
    return this.actions.slice(0, 3).map((action) => html`<aab-action class="mt-1 pl-2 action" label="${action.action}"
             ?disabled=${action.disabled} icon="${action.icon}" @click="${() => this.actionClick(action)}"></aab-action>`);
  }

  render() {
    return html`
      <div class="actionbar shadow-title p-2 d-flex justify-content-between align-items-center">
        <div class="title text-left text-intro">
          ${this.actionBarTitle ? this.actionBarTitle : ''}
        </div>
        <div class="d-flex justify-content-between">
          ${this.search ? html`<div class="search">
          <aab-input id="search" value="${this.searchValue}"
          @input=${this.inputChanged}
          placeholder="${this.searchPlaceholder}">
          <aab-icon class="d-flex align-items-center inputIcon" slot="icon" size="3"
          svg="${this.searchValue && this.searchValue.length > 0 ? closeIcon : searchIcon}"
          @click=${this.searchValue && this.searchValue.length > 0 ? this.clearSearch : this.focusSearchInput}>
          </aab-input></div>` : ''}
          ${this.actions.length > 0 ? this.renderActions() : ''}
        </div>
      </div>
    `;
  }
}
